import { useCallback, useEffect, useRef } from "react"
import { IconVideoOutline18 as Youtube } from "nucleo-ui-outline-18"

import type {
	CustomBodyParams,
	SlashCommandCustomBodyElement,
	SlashCommandDefinition,
} from "../types"
import { toast } from "@/components/toast"
import { iconClassName } from "../constants"
import { UrlInput } from "./url-input"

type YoutubeVideoCustomProps = CustomBodyParams & {
	url?: string
}

const youtubeRegex =
	/^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(?:-nocookie)?\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|live\/|v\/)?)([\w-]+)(\S+)?$/

const YoutubeVideoCommandBody: SlashCommandCustomBodyElement<
	YoutubeVideoCustomProps
> = ({ submit }) => {
	const inputRef = useRef<HTMLInputElement>(null)

	const onSubmit = useCallback(
		(url: string) => {
			if (!url) return
			if (!youtubeRegex.test(url)) {
				toast.error({ title: "Invalid YouTube video URL" })
				return
			}
			submit({ url })
		},
		[submit],
	)

	useEffect(() => {
		inputRef.current?.focus()
	}, [inputRef])

	return <UrlInput handleUrlSubmit={onSubmit} title={null}></UrlInput>
}

export const youtubeVideoCommand: SlashCommandDefinition<YoutubeVideoCustomProps> =
	{
		key: "youtube-video",
		title: "YouTube Video",
		bodyTitle: "Add YouTube Video",
		icon: <Youtube strokeWidth={1.75} className={iconClassName} />,
		command: ({ editor, range, customBodyParams: { url } }) => {
			if (!url) {
				editor.chain().focus().deleteRange(range)
				return
			}
			editor
				.chain()
				.focus()
				.deleteRange(range)
				.setYoutubeVideo({ src: url })
				.run()
		},
		customBody: YoutubeVideoCommandBody,
		group: "media",
	}
